<p-dialog header="{{headerFlow}}" [(visible)]="display && flowForm" [responsive]="true" [style]="{width: '60vw'}" [modal]="true" [closable]="true">
    <div class="p-grid">
        <div class="p-col-7">
            <form *ngIf="flowForm" [formGroup]="flowForm" novalidate>
                <div class="p-grid">
                    <div class="p-col-12">
                        <label>Header</label>
                        <input type="text" formControlName="header" pInputText />
                    </div>
                    <div class="p-col-12">
                        <label>Footer</label>
                        <input type="text" formControlName="footer" pInputText />
                    </div>
                    <div class="p-col-12">
                        <label>Body<span class="required-sign">*</span></label>
                        <!-- <input type="text" formControlName="body" pInputText /> -->
                        <textarea formControlName="body" pInputTextarea rows="5" cols="30"></textarea>
                        <div *ngIf="detailsFormErrors?.body" class="p-invalid">
                            <small>{{ detailsFormErrors?.body }}</small>
                        </div>
                    </div>
                    <div class="p-col-12">
                        <label>Call To Action<span class="required-sign">*</span></label>
                        <input type="text" formControlName="ctaText" pInputText />
                        <div *ngIf="detailsFormErrors?.ctaText" class="p-invalid">
                            <small>{{ detailsFormErrors?.ctaText }}</small>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="p-col-1">&nbsp;</div>
        <div class="p-col-4">
            <label>Preview</label>
            <p-card class="custom-padding">
                <h6 class="p-px-2" style="word-break: break-all;">{{flowForm?.value?.header}}</h6>
                <div style="word-break: break-all;">{{ flowForm?.value?.body }}</div>
                <p class="p-px-2" style="color: #888;word-break: break-all;">{{flowForm?.value?.footer}}</p>
            </p-card>
            <p-card class="custom-padding">
                <div class="p-text-center" style="color: #4c9edc;">{{flowForm?.value?.ctaText}}</div>
            </p-card>
        </div>
    </div>

    <p-footer>
        <div>
            <button type="button" pButton  label="Cancel" (click)="closeDialog()"
            class="p-button-secondary"></button>
        <button *ngIf="!isViewOnly" type="submit" pButton label="Submit" (click)="submitForm()"></button>
        </div>
    </p-footer>
</p-dialog>

